export const Messages = {
  commentNotSaved: 'Your comment was not saved, please try again',
  serviceUnavailable: 'Service is unavailable. Please check your internet connection or try again later'
};
